<template lang="pug">
  a-entity.scenes


    //logo(:modeSwitchable="true")
    //button-menu

    img(style="display:none" ref="texture" src="~assets/ui/photoTexture.png")
    img(style="display:none" ref="qr" src="~assets/ui/qrcode.jpg")
    av-player(v-if="ctaShowed" @next="cueNext" @end="cueEnd")
    //av-player-andriod(v-if="isAndroid" @next="cueNext" @end="cueEnd")
    template(v-if="mode === MODES.KIDS && !modeSwitching")
      .btn.btn-gallery(@click="btnBag")
        bag
      .btn.btn-camera(@click="btnCam")
        cam
    //template(v-if="mode === MODES.ADULTS && !modeSwitching")
      button-menu
    template(v-if="!modeSwitching")
      button-menu

    .subcontainer(v-if="showSubtitles && !sceneTrans")
      subtitles(:id="`scene${currSceneIdx+1}${mode === MODES.KIDS? 'kids': 'adults'}`")

    virtual-slides(ref="slide" dir="vertical" :initialSlide="id" @slideStart="slideStart" :class="{'stop-slide': sceneTrans}")

    goo-pagination
    scene-trans(v-if="sceneTrans" @next="goNext" @replay="replay")
    //scene-cta(v-if="!ctaShowed" @complete="ctaComplete")

    ending(v-if="sceneProgress >= 1" )

    //.showcase(@click="showCase")
    //mode-switch


</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power3} from 'gsap'

import * as MODES from 'src/config/modes'
import Bag from 'src/components/vca/widgets/Bag'
import Cam from 'src/components/vca/widgets/Cam'
import Gallery from 'src/components/vca/gallery/Gallery'
import Logo from 'src/components/vca/widgets/Logo'
import VirtualSlides from './VirtualSlides'
import ButtonMenu from 'src/components/vca/widgets/ButtonMenu'
import Menus from 'src/components/vca/menu/Menu'
import QRPage from 'src/components/vca/widgets/old/QRPage'

import AVPlayer from 'src/components/vca/widgets/AVPlayer2'

import Subtitles from 'src/components/vca/widgets/Subtitles'
import SceneTrans from 'src/components/vca/widgets/SceneTrans'
import SoundService from 'src/services/SoundService'
import * as PATHS from 'src/router/paths'
//import GooPagination from 'src/components/vca/widgets/GooPagination'
import SceneCta from "src/components/vca/widgets/SceneCta";
import Ending from "src/components/vca/ending/Ending";
import AnalyticsService from '@/services/AnalyticsService'
import GooPagination from 'src/components/vca/widgets/GooPagination2'


import ModeSwitch from "src/components/vca/widgets/ModeSwitch2"


export default {
  name: "Scenes",
  props: {
    id: {
      required: true
    }
  },
  components: {
    Ending,
    SceneCta,
    Bag,
    Cam,
    Gallery,
    Logo,
    VirtualSlides,
    ButtonMenu,
    Menus,
    'qr-page':QRPage,
    'av-player': AVPlayer,
    Subtitles,
    SceneTrans,
    GooPagination,

    ModeSwitch

  },
  data() {
    return {
      MODES,
      sceneTrans: false,
      ctaShowed: false,
      gtags: [
        'yosemite',
        'redwoods',
        'santabarbara',
        'montereybay',
        'lajolla'
      ],
    }
  },

  computed:{

    ...mapState('app', ['mode', 'modeSwitching', 'showMenu', 'showGallery', 'showQRPage', 'seenIntro', 'sceneProgress', 'mode', 'showDestInfo', 'showSubtitles', 'muted', 'sceneEntered', 'currSceneIdx','bgm']),
    ...mapState('browser', ['windowWidth', 'windowHeight', 'isAndroid']),
    bgHeight() {
      return this.windowHeight+100
    },
    bgWidth() {
      // let img = document.querySelector('#hub-bg')
      // let ratio = img.naturalWidth / img.naturalHeight
      let ratio = 1535 / 1024


      return this.bgHeight * ratio
    }

  },
  methods: {
    ...mapMutations('app', ['toggleDestInfo', 'addToGallery', 'openGallery', 'setSceneEntered', 'setMode', 'lockMode', 'unlockMode', 'pauseBgm', 'setSceneComplete']),
    showCase(){
      console.log(999)
      window.App.switchMode()
    },
    init() {
      this.setSceneComplete(false)


      setTimeout(() => {
        this.ctaComplete()
      }, 0)

    },
    animate() {},
    cueNext(id){
      //console.log(4322929, this.$refs.slide.swiper, id)
      this.nextIdx = id
      this.sceneTrans = true
    },
    cueEnd(){
      this.setSceneComplete(true)
      //alert('ending')
      // this.$router.replace({
      //   name: PATHS.ENDING
      // })
      this.$refs.slide.swiper.slideTo(5)
    },
    goNext(){
      this.sceneTrans = false
      this.$refs.slide.swiper.slideTo(this.nextIdx)
    },
    replay(){
      this.sceneTrans = false
      window.AVPlayer.soundReplay()
    },
    slideStart(){
      // window.GyroView.stopRolling()
      // setTimeout(() => {
      //   window.GyroView.resumeRolling()
      // },2000)
    },
    btnBag(){
      AnalyticsService.sendEvent('scene', 'click', 'button-bag')
      this.openGallery()
    },
    btnCam(){
      AnalyticsService.sendEvent('scene', 'click', `button-camera`)
      AnalyticsService.sendEvent('scene', 'snapshot', `0${this.currSceneIdx+1}-${this.gtags[this.currSceneIdx]}`)
      this.snapShot()
    },

    snapShot(){
      window.AudioPlayer.playSnapshotSound()

      let img = new Image()
      // let canvas = document.querySelector('.a-canvas')
      let capture = document.querySelector('a-scene').components.screenshot
      let w = Math.floor(window.innerWidth/4)*4
      let h = Math.floor(w*1.52/4)*4
      capture.data.width = w
      //capture.data.height = window.innerHeight
      capture.data.height = h
      //console.log(capture)
      let canvas = capture.getCanvas('perspective')
      let ctx = canvas.getContext('2d')
      let cropHRatio = (window.innerHeight-h)/2/window.innerHeight
      //let data = ctx.getImageData(0, cropHRatio*h, w, (1-cropHRatio*2)*h)
      ctx.drawImage(canvas, 0, cropHRatio*h, w, (1-cropHRatio*2)*h, 0, 0, w, h)

      let canvas2 = document.createElement('canvas')
      canvas2.width = w/5
      canvas2.height = h/5
      let ctx2 = canvas2.getContext('2d')
      ctx2.drawImage(canvas, 0, cropHRatio*h, w, (1-cropHRatio*2)*h, 0, 0, w/5, h/5)

      let canvas3 = document.createElement('canvas')
      canvas3.width = w*0.8
      canvas3.height = h*0.8
      let ctx3 = canvas3.getContext('2d')
      ctx3.drawImage(canvas, 0, cropHRatio*h, w, (1-cropHRatio*2)*h, 0, 0, w*0.8, h*0.8)


      let pic = canvas.toDataURL('image/jpeg', 0.8)
      let thumbS = canvas2.toDataURL('image/jpeg', 1)
      let thumbM = canvas3.toDataURL('image/jpeg', 0.9)
      //console.log(pic)


      let scale = 2
      let borderWR = 0.1
      let borderBottomR = 0.25
      let qrWR = 0.22
      let cw = w*(1+borderWR*2) * scale
      let ch = h*(1+borderBottomR+borderWR) * scale

      let canvasQr = document.createElement('canvas')
      canvasQr.style.letterSpacing = "10px"
      canvasQr.width = cw
      canvasQr.height = ch
      ctx = canvasQr.getContext('2d')

      let frame1ofs = -8
      let frame2ofs = 5

      ctx.fillStyle = "#5e71a2"
      ctx.fillRect(0, 0, cw, ch)
      ctx.fillStyle = "#5376C7"
      ctx.fillRect(-10, -10, cw, ch)
      let texture = this.$refs.texture
      ctx.drawImage(texture, 0, 0, texture.naturalWidth, texture.naturalHeight, 0, 0, cw, ch)

      ctx.fillStyle = "#7e7a8c"
      ctx.fillRect(borderWR*w * scale+frame1ofs, borderWR*w * scale+frame1ofs, w * scale, h * scale)
      ctx.fillStyle = "#c9c1b9"
      ctx.fillRect(borderWR*w * scale+frame2ofs, borderWR*w * scale+frame2ofs, w * scale, h * scale)

      ctx.drawImage(canvas, 0, 0, w, h, borderWR*w * scale, borderWR*w * scale, w * scale, h * scale)
      let qr = this.$refs.qr
      let qrCropMargin = 30
      let qrW = qr.naturalWidth-qrCropMargin*2
      let qrDrawW = w*qrWR * scale

      let qrOffX = cw-borderWR*w * scale-qrDrawW
      let qrOffY = ch-borderWR*w * scale-qrDrawW

      let qrFrameBorderW = 15
      qrOffX-=qrFrameBorderW
      qrOffY-=qrFrameBorderW
      let qrFrameOffX = qrOffX-qrFrameBorderW
      let qrFrameOffY = qrOffY-qrFrameBorderW
      let qrFrameW = qrDrawW+qrFrameBorderW*2



      let textH = 0.04*w * scale
      let textOffX = borderWR*w * scale
      let textOffY = ch-borderWR*w * scale-textH/2+15

      let titleH = 0.07*w * scale
      let titleOffX = borderWR*w * scale
      let titleOffY = ch-borderWR*w * scale-titleH/2-textH-10
      let titleOffY2 = ch-borderWR*w * scale-titleH*1.5-textH-30

      let date = new Date()
      //console.log(date.getFullYear(), date.getMonth(), date.getDay(), date.getDate())


      ctx.fillStyle = "#f7a41a"
      ctx.font = `${textH}px VCA`
      //ctx.fillText(`${date.getFullYear()}年${date.getMonth()+1}月${date.getDate()}日`, textOffX, textOffY)
      ctx.save()
      ctx.translate( textOffX+10, textOffY)
      ctx.rotate(-0.1)
      this.fillTextWithSpacing(ctx, `${date.getFullYear()}年${date.getMonth()+1}月${date.getDate()}日`, 0, 0, 2)
      ctx.restore()
      ctx.fillStyle = "#F8DEB1"
      ctx.font = `${titleH}px VCA`
      //ctx.fillText(`我的奇妙加州时光！`, titleOffX, titleOffY)
      ctx.save()
      ctx.translate(titleOffX, titleOffY)
      ctx.rotate(-0.1)
      this.fillTextWithSpacing(ctx, `激发你的无穷想象！`, 0, 0, 5)
      ctx.restore()
      ctx.save()
      ctx.translate(titleOffX-10, titleOffY2)
      ctx.rotate(-0.1)
      this.fillTextWithSpacing(ctx, `去加州，`, 0, 0, 5)
      ctx.restore()

      ctx.fillStyle = "#F8DEB1"
      ctx.fillRect(qrFrameOffX, qrFrameOffY, qrFrameW, qrFrameW)
      ctx.drawImage(qr, qrCropMargin, qrCropMargin, qrW, qrW, qrOffX, qrOffY, qrDrawW, qrDrawW)
      let picQr = canvasQr.toDataURL()

      // img.src = picQr
      // img.style.width = '300px'
      // img.style.zIndex = '999'
      // img.style.display = 'block'
      // img.style.position = 'absolute'
      // console.log(canvas, img)
      // this.$el.appendChild(img)


      this.addToGallery([pic,picQr, thumbS, thumbM])
      //document.querySelector('a-scene').components.screenshot.capture('perspective')

    },
    fillTextWithSpacing (context, text, x, y, spacing) {
      //Start at position (X, Y).
      //Measure wAll, the width of the entire string using measureText()
      let wAll = context.measureText(text).width
      let wShorter = 0
      do
      {
        //Remove the first character from the string
        let char = text.substr(0, 1)
        text = text.substr(1)

        //Print the first character at position (X, Y) using fillText()
        context.fillText(char, x, y)

        //Measure wShorter, the width of the resulting shorter string using measureText().
        if (text == "")
          wShorter = 0
        else
          wShorter = context.measureText(text).width

        //Subtract the width of the shorter string from the width of the entire string, giving the kerned width of the character, wChar = wAll - wShorter
        let wChar = wAll - wShorter

        //Increment X by wChar + spacing
        x += wChar + spacing

        //wAll = wShorter
        wAll = wShorter

        //Repeat from step 3
      } while (text != "")
    },
    panLimit(){
      let camera = document.querySelector('.camera')

      camera.components['gyro-position'].enableListener()
      camera.components['gyro-position'].limitX = this.bgWidth / 2 - this.windowWidth / 2
      camera.components['gyro-position'].limitY = this.bgHeight / 2 - this.windowHeight / 2
      //camera.components['gyro-position'].multiplier = 0.5

      //console.log(camera.components['gyro-position'])

    },
    restoreLimit(){
      //let camera = document.querySelector('.camera')
      this.camera.components['gyro-position'].disableListener()
      this.camera.components['gyro-position'].limitX = 0
      this.camera.components['gyro-position'].limitY = 0

      //console.log(camera.components['gyro-position'].offset, camera.components['gyro-position'].target)
    },
    ctaComplete(){
      this.ctaShowed = true
      this.panLimit()
      this.unlockMode()
      window.AudioPlayer.stopTransBgm()
      //window.GyroView.animeOut()
      window.MapTitle.animeOut(this.currSceneIdx)
    }
    // playVid(id){
    //   if (this.vid)
    //     this.vid.pause()
    //   this.vid = document.getElementById('anime'+id)
    //   this.vid.play()
    // },
    // end(){
    //   this.$router.replace({
    //     name: 'ending',
    //   })
    // },
    // playSoundFromStart(id){
    //   if (this.sound) this.sound.pause()
    //   this.sound = SoundService.get(id)
    //   this.sound.currentTime = 0
    //   this.sound.on('end', () => {
    //     this.end()
    //   })
    //   if (this.muted){
    //     this.sound.muted = true
    //   } else {
    //     this.sound.muted = false
    //   }
    //   if (this.sound) this.sound.play()
    // },
  },
  // beforeMount(){
  //   this.setMode(0)
  // },
  beforeMount(){
    this.setSceneEntered(true)
    window.App.camGyroOn()
    this.lockMode()

  },
  mounted() {
    AnalyticsService.sendPageview(`/scene`)
    AnalyticsService.sendPageview(`/scene/adults`)
    this.init()
    this.animate()

    //this.pauseBgm()

    window.Scene = this
    this.camera = document.querySelector('.camera')
    //this.panLimit()
    //
    // setTimeout(() => {
    //  this.panLimit()
    //  //this.playVid(this.id+1)
    // }, 1000)
  },

  beforeDestroy(){
    this.restoreLimit()
    this.setSceneEntered(false)
    this.lockMode()
  },
  watch: {

    showMenu(val){
      if (val) {
        //this.camera.components['gyro-position'].disableListener()
        //window.App.camGyroOff()
        this.restoreLimit()

      } else {
        //this.camera.components['gyro-position'].enableListener()
        //window.App.camGyroOn()
        this.panLimit()
      }
    },
    showGallery(val){
      if (val) {
        //this.camera.components['gyro-position'].disableListener()
        //window.App.camGyroOff()
        this.restoreLimit()

      } else {
        //this.camera.components['gyro-position'].enableListener()
        //window.App.camGyroOn()
        this.panLimit()
      }
    },

    sceneProgress(value){
      //console.log(value)
      let val = value*4.0
      //console.log(999, Math.abs(0.5-val%1.0))
      //let f = 1.0-Math.abs(0.5-val%1.0)*2.0
      //f = this.easeOutCubic(f)
      //this.setCamZoom(f)
      //this.setCamDistort(f)


      // if (val > 3) {
      //   this.p5 = val - 3.0
      //   this.p4 = 1
      // }else if(val > 2){
      //   this.p5 = 0
      //   this.p4 = val - 2.0
      //   this.p3 = 1
      // }else if(val > 1){
      //   this.p4 = 0
      //   this.p3 = val - 1.0
      //   this.p2 = 1
      // } else {
      //   this.p3 = 0
      //   this.p2 = val
      // }
      //console.log(333,val, this.p2, this.p3, this.p4)
      if (Math.floor(val) === val && this.currIdx !== val+1){
        this.currIdx = val+1
        //this.playVid(this.currIdx)

        // if(this.mode === MODES.KIDS){
        //   //   let vid = document.getElementById('anime1')
        //   //   //console.log(888, vid)
        //   //   vid.play()
        //   this.playSoundFromStart('kids')
        // }else{
        //   this.playSoundFromStart(`scene${this.id+1}adults`)
        // }
        // if(this.mode === MODES.KIDS){
        //   //   let vid = document.getElementById('anime1')
        //   //   //console.log(888, vid)
        //   //   vid.play()
        //   this.playSoundFromStart('kids')
        // }else{
        //   this.playSoundFromStart('adults')
        // }
      }

    }
  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .scenes
    +full()
    .btn
      z-index: 190
      pointer-events: all
      position: absolute
      bottom: 0
      //background: #3a54a2
      img
        position: relative
        width: 100%
        height: auto
        object-fit: cover
        display: block
      //.bag
      //position: relative
      //object-fit: cover
      //display: block
    .btn-gallery
      left: 0
      position: static
    .btn-camera
      //background: red
      right: 0
      //width: 8rem
    .gallery
      z-index: 220
    .logo
      z-index: 800
    .button-menu
      z-index: 110
    .menu
      z-index: 900

    .scene-trans
      z-index: 999
    .scene-cta
      z-index: 999
    .goo-pagination
      z-index: 120
    .virtual-slide
      &.stop-slide
        pointer-events: none
    .subcontainer
      //background: greenyellow
      pointer-events: none
      z-index: 200
      position: absolute
      width: 100%
      height: 1rem
      bottom: 0.3rem
      .subtitles
        //background: #ffd81b
        color: white
        font-size: $fs-m
    //.mode-switch
      z-index: 100
    .showcase
      pointer-events: all
      z-index: 99999
      width: 50%
      height: 50%
      position: absolute
      top: 25%
      left: 25%
      //background: #e15125

</style>